import { useEffect } from 'react';

export const useMountEffect = f => useEffect(f, []);
